import { DataList } from '@brighte/form-components';

export default function StepSummary({ completedContent }) {
  if (!completedContent) return null;

  return completedContent?.map(({ title, items }, index) => (
    <DataList title={title} items={items} key={`${title}-${index}`} />
  ));
}
